import React from "react";
import Sidebar from "../../../Components/Sidebar";
import AddMessageForm from "../../../Components/AddMessageForm";
import DisplayMessage from "./DisplayMessage";
import { LuTarget, LuUserCheck } from "react-icons/lu";
import { FaHistory } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PageComponent from "../../../Components/PageComponent";

function LeadershipMessages() {
  const navigate = useNavigate();

  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      {/* Sidebar */}
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>

      {/* Content Section */}
      <div className="flex-1 p-6 ml-64">
        {/* Breadcrumb */}
        <div className="flex items-center mb-6 space-x-2 text-3xl text-gray-500">
          <span>About Us</span>
          <span>/</span>
          <span className="text-black">About SAB Campus</span>
        </div>

        {/* Buttons */}
        <div className="flex items-center mt-4 mb-5 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/aboutus/vision")}
          >
            <LuTarget className="mr-2" />
            Vision & Mission
          </button>
           <button
              className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
              onClick={() => navigate("/aboutus/history")}
            >
              <FaHistory className="mr-2" />
              Our History
            </button>
          <button className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
          onClick={() => navigate("/aboutus/leadershipMessage")}>
            <LuUserCheck className="mr-2" />
            Leadership Messages
          </button>
        </div>

        {/* Forms */}
        <AddMessageForm title="Add Leadership Message" />
        <DisplayMessage />
      </div>
    </div>
    </PageComponent></>
  );
}

export default LeadershipMessages;
